export default __webpack_public_path__ + "static/p1-ddb2061a13607c4cc86361f1654f8e8a.png";